import { render, staticRenderFns } from "./proxy-products.vue?vue&type=template&id=74ef68e6&scoped=true"
import script from "./proxy-products.vue?vue&type=script&lang=js"
export * from "./proxy-products.vue?vue&type=script&lang=js"
import style0 from "./proxy-products.vue?vue&type=style&index=0&id=74ef68e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ef68e6",
  null
  
)

export default component.exports